import React, { FC, ChangeEvent, useEffect, useRef, useState } from 'react';
import { Button, Stack, TextField, Typography, Slide } from '@mui/material';
import { EventUpdateSizeScale, EventUpdateSizeScaleType } from '../../../helpers/events';
import { Edit } from '../../../constructor/work/Edit';

interface Props {
  isOpen: boolean;
}
export const SetScaleComponent: FC<Props> = ({ isOpen }) => {
  const [customSize, setCustomSize] = useState('0');
  const oldSize = useRef(0);

  const onChangeText = (evt: ChangeEvent<HTMLInputElement>) => {
    const text = evt.target.value.replace(/[^0-9]/g, '');
    setCustomSize(text);
  };
  const onButtonClick = () => {
    Edit.removeSetScaleObject();
    if (Edit.drawingSubstrate) {
      const coif = +customSize / oldSize.current;
      Edit.drawingSubstrate.updateScale(coif);
    }
  };
  const updateScaleSize = (evt: CustomEvent<EventUpdateSizeScaleType>) => {
    setCustomSize((evt.detail.size * 1000).toFixed());
    oldSize.current = evt.detail.size * 1000;
  };

  useEffect(() => {
    document.addEventListener(EventUpdateSizeScale, updateScaleSize);
    return () => {
      document.removeEventListener(EventUpdateSizeScale, updateScaleSize);
    };
  }, []);

  return (
    <Slide direction="down" in={isOpen} mountOnEnter unmountOnExit>
      <Stack
        width="220px"
        height="120px"
        position="absolute"
        top="30px"
        left="calc(100% / 2 - 150px)"
        flexGrow={1}
        spacing={2}
        pt={3}
        pl={5}
        pr={5}
        borderRadius={4}
        bgcolor="white"
        sx={{
          boxShadow: '11px 10px 26px 1px rgba(0,0,0,0.75)',
        }}
      >
        <TextField
          autoComplete="off"
          // autoFocus
          value={customSize}
          inputMode="decimal"
          label="Выставить свой размер"
          fullWidth
          size="small"
          onChange={onChangeText}
        />
        <Button variant="contained" size="large" onClick={onButtonClick}>
          <Typography fontSize="16px" color="white">
            Свой размер
          </Typography>
        </Button>
      </Stack>
    </Slide>
  );
};
